import { ERouteHttpVerb } from "@devowl-wp/api";
const routeLocationUserGet = {
    path: "/user",
    method: ERouteHttpVerb.GET
};
export { routeLocationUserGet };
